(function ($, App, Utils, Components) {
  'use strict';

  const log = new Logger('Profiling');

  Components.create('Profiling', {

    Selectors: {
      form: '.js-update-profile-form',
      submit: '.js-update-profile',
      checkMarketing: '#privacyMarketing1',
      checkProfiling: '#privacyProfiling1',
      closeModal: '.js-close-modal',
      sendForm: '.js-send-form',
      resetForm: '.js-reset-form'
    },

    bindEvents: function () {
      let $form = $(Components.Profiling.Selectors.form),
          $marketing = $(Components.Profiling.Selectors.checkMarketing),
          $profiling = $(Components.Profiling.Selectors.checkProfiling),
          $modal = $form.find('[data-modal="true"]');

      $form.submit(function (e) {

        let validationFailed = false;
        let check = $(Components.Profiling.Selectors.submit).attr('data-profiling') === 'true' ? true : false;

        if (check && ($marketing.is(":checked") === false || $profiling.is(":checked") === false)) {
          validationFailed = true;
          $(Components.Profiling.Selectors.submit).attr('data-profiling', false)

          $modal.trigger('click');

          $(Components.Profiling.Selectors.closeModal).on('click', () => {
            vex.closeAll();
			      $(Components.Profiling.Selectors.submit).prop('disabled', false);
          })

          $(Components.Profiling.Selectors.sendForm).on('click', () => {
            validationFailed = false;
            $form.submit();
          })

        }

        if (validationFailed) {
          e.stopPropagation();
          return false;
        }

      });

      $form.on('reset', () => {
        //reset select2
        const selectElements = document.querySelectorAll('select');
        setTimeout(function(){
          selectElements.forEach(selectElement => {
            selectElement.value = selectElement.options[0].value;
            const event = new Event('change',{bubbles:true});
            selectElement.dispatchEvent(event);
            
          });
        },0);

      })
    },

    init: function () {
      Components.Profiling.bindEvents();
    }

  });

})(jQuery,
    window.App,
    window.App.Utils,
    window.App.Components
);